<template>
  <div class='PropProd'>
    <div class="cont-check-delete">
      <div class="cont-check">
        <input type="checkbox" @change="updateActive" :checked="data.active">{{ data.name }}
      </div>
      <div class="cont-btn-delete">
        <delete-icon @click="del" color="#CCCCCC" :options="{ width: '22px', height: '22px' }" />
      </div>
    </div>
    <div>
      <label style="font-size: 12px; padding: 3px;" v-if="data.values.length">Valores:</label>
      <div class="cont-values" v-if="data.values.length">
        <div
        class="value"
        v-for="(value, k) in data.values"
        :key="k"
        >
          <input type="checkbox" @change="updateValue(value)" :checked="value.active">
          {{ value.name }}
          <delete-icon @click="delValue(value.id)" color="#CCCCCC" :options="{ width: '22px', height: '22px' }"/> |
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DeleteIcon from '@/components/EnbPainel/Icons/DeleteIcon'
export default {
  name: 'PropProd',
  components: { DeleteIcon },
  props: ['data'],
  data () {
    return {
      value: ''
    }
  },
  methods: {
    ...mapActions(['UpdatePropProd', 'UpdateValueProp', '_UpdateAtr', 'SetModal']),
    updateValue (value) {
      this.UpdateValueProp({ prop: this.data, value: value })
        .then(() => this._UpdateAtr(this.data))
    },
    updateActive () {
      this.UpdatePropProd(this.data)
        .then(() => this._UpdateAtr(this.data))
    },
    del () {
      this.SetModal({ 
        component: 'AskAction',
        active: true,
        ask: 'Tem certeza que deseja excluir o atributo?',
        action: '_DeleteAtr',
        payload: this.data.id
      })
    },
    delValue (id) {
      this.SetModal({ 
        component: 'AskAction',
        active: true,
        ask: 'Tem certeza que deseja excluir o valor?',
        action: '_DeleteAtrValue',
        payload: id
      })
    }
  }
}
</script>

<style scoped>
.PropProd {
  border: thin solid #CCCCCC;
  border-radius: 5px;
  padding: 1.5%;
  margin-top: 1%;
  text-align: left;
}

.cont-values {
  display: flex;
  flex-wrap: wrap;
  padding: 1.5%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  font-size: 14px;
}

.cont-check-delete {
  display: flex;
  align-items: center;
}

.cont-check {
  width: 90%;
}

.cont-btn-delete {
  width: 10%;
  display: flex;
  justify-content: end;
}

.value-btn {
  display: flex;
  justify-content: end;
  align-items: end;
}

.value {
  display: flex;
  align-items: center;
  margin: 0%;
}

button {
  border: 0;
  padding: 0.92%;
  height: 35px;
  border-radius: 5px;
  background-color: #CCCCCC;
  cursor: pointer;
}
</style>
